<template>
  <div class="blog-container">
    <div class="m-1">
      <Ad placementName="video" class="video-ad"/>
    </div>
    <ul class="blog-list p-4 m-3">
      <li><b>Introduction</b></li>
      <ul>
        <li><b-link href="/introduction">Terror Zone Introduction</b-link></li>
      </ul>
      <div class="blog-block">
        <div>
          <li><b>Some Terror Zones Run Guides</b></li>
          <ul>
            <li><b-link href="/blog?zones=chaos-sanctuary">Chaos Sanctuary</b-link></li>
            <li><b-link href="/blog?zones=wsk">Worldstone Keep &amp; Throne of Destruction</b-link></li>
            <li><b-link href="/blog?zones=moo-moo-farm">Moo Moo Farm</b-link></li>
            <li><b-link href="/blog?zones=halls-of-the-dead">Dry Hills and Halls of the Dead</b-link></li>
            <li><b-link href="/blog?zones=stony-tomb">Rocky Waste &amp; Stony Tomb</b-link></li>
            <li><b-link href="/blog?zones=pit">The Pit</b-link></li>
            <li><b-link href="/blog?zones=travincal">Travincal</b-link></li>
            <li><b-link href="/blog?zones=flayer-jungle">Flayer Jungle &amp; Flayer Dungeon</b-link></li>
            <li><b-link href="/blog?zones=arcane-sanctuary">Arcane Sanctuary</b-link></li>
          </ul>
        </div>
        <div>
          <li><b>Builds for All Terror Zones Runs</b></li>
          <ul>
            <li><b-link href="/blog?build=mosaic-asn">Mosaic Assassin</b-link></li>
            <li><b-link href="/blog?build=hammerdin">Blessed Hammer Paladin</b-link></li>
            <li><b-link href="/blog?build=nova-sor">Nova Sorceress</b-link></li>
            <li><b-link href="/blog?build=lightning-sor">Lightning Sorceress</b-link></li>
            <li><b-link href="/blog?build=lightning-javazon">Lightning Javazon</b-link></li>
            <li><b-link href="/blog?build=summon-nec">Summoner Necromancer</b-link></li>
            <li><b-link href="/blog?build=bow-ama">Physical Bow Amazon</b-link></li>
            <li><b-link href="/blog?build=fireclaws-dru">Fire Claws Werebear Druid</b-link></li>
            <li><b-link href="/blog?build=berserker-barb">Berserker Barbarian</b-link></li>
            <li><b-link href="/blog?build=wind-dru">Wind Druid</b-link></li>
          </ul>
        </div>
      </div>
    </ul>
  </div>
</template>

<script>
import Ad from './Ad.vue'

export default {
  name: 'BlogList',

  components: {
    Ad,
  },
}
</script>

<style scoped>
.blog-container {
  width: 400px;
}
.blog-list {
  border: 2px solid #fff;
  border-radius: 25px;
}
.blog-list li a {
  color: #fff;
}
.blog-block {
  display: flex;
  flex-flow: wrap;
}
.video-ad {
  max-width: 800px;
}
@media (max-width: 1000px) {
  .blog-container {
    max-width: 800px;
    width: 100%;
  }
}
</style>